export const BillingTableConf = [
  {
    isSortable: false,
    field: 'invoice',
    title: 'Invoice ID'
  },
  {
    isSortable: false,
    field: 'description',
    title: 'Description'
  },
  {
    isSortable: true,
    field: 'date',
    title: 'Date'
  },

  {
    isSortable: true,
    field: 'total',
    title: 'Amount'
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status'
  },

  {
    isSortable: false,
    field: 'Download',
    title: ''
  }
];
